<template>
    <router-view></router-view>

</template>

<script>

    export default {
        name: 'App',
        components: {},
        async created() {

        }
    }
</script>

<style>
.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by{
  display: none!important;
}
</style>
